import { render } from "./PartnerDetails.vue?vue&type=template&id=5c31328d&scoped=true"
import script from "./PartnerDetails.vue?vue&type=script&lang=js"
export * from "./PartnerDetails.vue?vue&type=script&lang=js"

import "./PartnerDetails.vue?vue&type=style&index=0&id=5c31328d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c31328d"]])

export default __exports__